<template>
  <div class="container">
    <h1>Данные по марке</h1>

    <!-- search -->
    <div id="searchGroup" class="d-flex justify-content-center m-3 btn-group">
      <input
        v-model="cis"
        type="text"
        class="form-control"
        placeholder="Марка"
        @change="getMarkInfo()"
      />
      <button class="btn btn-primary" @click="getMarkInfo()">ОБНОВИТЬ</button>
    </div>

    <div class="m-3">
      <div class="row">
        <div class="col">
          <h3>{{ markInfoData.cis }}</h3>
        </div>
      </div>

      <div v-if="markInfoData.productName" class="row border border-secondary m-2 p-2 rounded-2">
        <div class="col">{{ markInfoData.productName }}</div>
      </div>

      <div v-if="markInfoData.routeSheetName" class="row border border-secondary m-2 p-2 rounded-2">
        <div class="col">{{ markInfoData.routeSheetName }}</div>
      </div>

      <div v-if="markInfoData.orderName" class="row border border-secondary m-2 p-2 rounded-2">
        <div class="col">{{ markInfoData.orderName }}</div>
      </div>

      <div v-if="markInfoData.invoiceName" class="row border border-secondary m-2 p-2 rounded-2">
        <div class="col">{{ markInfoData.invoiceName }}</div>
      </div>

      <div v-if="markInfoData.isReturned" class="row border border-secondary m-2 p-2 rounded-2">
        <div class="col">ВОЗВРАТ</div>
      </div>

      <div v-if="markInfoData.status" class="row border border-secondary m-2 p-2 rounded-2">
        <div class="col">{{ markInfoData.status }}</div>
      </div>

      <div v-if="markInfoData.ownerInn" class="row border border-secondary m-2 p-2 rounded-2">
        <div class="col">{{ markInfoData.ownerInn }}</div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import useCommonMixin from "@/components/commonMixin.js";

export default {
  setup() {
    const cis = ref("");
    const markInfoDataEmpty = {
      cis: "",
      productName: "",
      routeSheetName: "",
      invoiceName: "",
      orderName: "",
      status: "",
      ownerInn: "",
      isReturned: false
    };

    const markInfoData = ref(markInfoDataEmpty);
    const {
      // dateFormat,
      // settings,
      markInfo,
      getSettings,
    } = useCommonMixin();

    const getMarkInfo = async () => {
      console.log(cis.value);
      markInfoData.value = markInfoDataEmpty

      let reqData = { cis: cis.value };
      let markInfoResp = await markInfo(reqData);
      if (markInfoResp && markInfoResp.status) {
        markInfoData.value = markInfoResp.data;
      }

      if (!markInfoResp || !markInfoResp.status) {
        markInfoData.value.cis = markInfoResp.errorMsg;
      }
    };

    onMounted(async () => {
      await getSettings();
    });

    return {
      cis,
      getMarkInfo,
      markInfoData,
    };
  },
};
</script>
